import { render, staticRenderFns } from "./SignSuperSimple.vue?vue&type=template&id=5b09868a"
import script from "./SignSuperSimple.vue?vue&type=script&lang=js"
export * from "./SignSuperSimple.vue?vue&type=script&lang=js"
import style0 from "./SignSuperSimple.vue?vue&type=style&index=0&id=5b09868a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports